module.exports = __webpack_public_path__ + "static/media/page-0002.dc2bfd3a.jpg";